const ORIGIN = 'https://www.blaketechnologies.com';
const pages = {
  '/': {
    title: 'Custom Software & AI Development | Blake Technologies',
    description: 'Blake Technologies builds custom software, AI automation, and connected systems for businesses, service companies, and private equity portfolios.'
  },
  '/clients': {
    title: 'Software Development for Businesses | Blake Technologies',
    description: 'Turn business workflows into reliable software. Explore technology assessments, AI automation, custom applications, integrations, and ongoing support.'
  },
  '/private-equity': {
    title: 'Technology & AI for Private Equity | Blake Technologies',
    description: 'Assess software and AI opportunities across your private equity portfolio. Build practical business cases, implement solutions, and support adoption.'
  },
  '/technologies': {
    title: 'Software Engineering & AI Technologies | Blake Technologies',
    description: 'Explore our software engineering capabilities across AI, web and mobile applications, cloud platforms, data, and enterprise systems integration.'
  },
  '/our-company': {
    title: 'Our Company & Engineering Teams | Blake Technologies',
    description: 'Meet the structure behind Blake Technologies: hands-on technical leadership and collaborative engineering teams focused on enterprise software delivery.'
  },
  '/contact': {
    title: 'Contact Our Software Development Team | Blake Technologies',
    description: 'Talk with Blake Technologies about custom software, AI automation, or a technology assessment for your business or private equity portfolio.'
  }
};
function pageMetadata(pathname) {
  const path = pathname.replace(/\/+$/, '') || '/';
  return Object.hasOwn(pages, path) ? { ...pages[path], canonical: ORIGIN + path } : null;
}
function metadataTags(meta) {
  return [
    ['meta', { name: 'description', content: meta.description }],
    ['link', { rel: 'canonical', href: meta.canonical }],
    ...Object.entries({ 'og:type': meta.type || 'website', 'og:site_name': 'Blake Technologies', 'og:title': meta.title, 'og:description': meta.description, 'og:url': meta.canonical }).map(([property, content]) => ['meta', { property, content }]),
    ...Object.entries({ 'twitter:card': 'summary', 'twitter:title': meta.title, 'twitter:description': meta.description }).map(([name, content]) => ['meta', { name, content }])
  ];
}
module.exports = { pages, pageMetadata, metadataTags, ORIGIN };
